var S = Object.defineProperty;
var P = (n, e, t) => e in n ? S(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var l = (n, e, t) => P(n, typeof e != "symbol" ? e + "" : e, t);
import { isSchemaNotBoolean as u, isObjectType as d } from "./types.js";
import { isNotNil as g, equalsWhenLowerCased as p } from "../../shared/utils.js";
import { StepParamsObjectSchemaHandler as c } from "./step-params-object-schema-handler.js";
import { JSONSchemaHandler as h } from "./json-schema-proxy.js";
import { m as O } from "../../memoize-Dw9XsDDv.js";
class v {
  constructor(e, t = [], r = !0, a) {
    l(this, "getCurrentlyResolvedStepParamsObjectSchemaHandler");
    this.schema = e, this.excludedFields = t, this.showRoutingParam = r, this.getRoutingParamValue = a;
    const i = (s) => {
      if (!this.getRoutingParamValue(s))
        return new c(
          this.getRoutingParamObjectSchema(),
          this.excludedFields
        );
      const o = this.getSelectedObjectSchemaWithExtendedRoutingParam(s);
      return o ? new c(
        o,
        this.excludedFields
      ) : new c(
        this.getRoutingParamObjectSchema(),
        this.excludedFields
      );
    };
    this.getCurrentlyResolvedStepParamsObjectSchemaHandler = O(
      i.bind(this),
      this.getRoutingParamValue.bind(this)
    );
  }
  getRoutingParamObjectSchema() {
    return {
      type: "object",
      properties: this.showRoutingParam ? {
        [this.routingParam]: {
          type: "string",
          enum: this.getRoutingParamOptions()
        }
      } : {},
      required: [this.routingParam]
    };
  }
  getFieldLogicLanguage(e, t) {
    return this.getCurrentlyResolvedStepParamsObjectSchemaHandler(e.params).getFieldLogicLanguage(
      e,
      t
    );
  }
  getFieldLogicLanguageOptions(e, t) {
    return this.getCurrentlyResolvedStepParamsObjectSchemaHandler(e.params).getFieldLogicLanguageOptions(
      e,
      t
    );
  }
  get routingParam() {
    var e;
    return ((e = this.schema.routingParams) == null ? void 0 : e[0]) ?? "";
  }
  getRoutingParamSchema(e) {
    return new h(e).getPropertySchema(this.routingParam);
  }
  getSelectedObjectSchema(e) {
    if (!this.routingParam)
      return {};
    const r = this.getRoutingParamValue(e);
    return {
      ...this.schema.oneOf.filter(u).filter(d).find((a) => {
        var s;
        const i = this.getRoutingParamSchema(a);
        return g(i) ? (s = i.enum) == null ? void 0 : s.find(
          (m) => p(m, r)
        ) : !1;
      }),
      definitions: this.schema.definitions
    };
  }
  getSelectedObjectSchemaWithExtendedRoutingParam(e) {
    const t = this.getSelectedObjectSchema(e);
    if (!t)
      return;
    const r = {
      type: "string",
      enum: this.getRoutingParamOptions()
    }, a = new h(t);
    return a.updatePropertySchema(this.routingParam, r), a.addPropertyToRequired(this.routingParam), a.schema;
  }
  getRoutingParamOptions() {
    return this.routingParam ? this.schema.oneOf.filter(u).filter(d).map((a) => this.getRoutingParamSchema(a)).filter(g).flatMap((a) => a.enum ?? []).filter((a) => typeof a == "string") : [];
  }
  getFields(e) {
    return this.getCurrentlyResolvedStepParamsObjectSchemaHandler(e).getFields(e);
  }
  getUpdatedState(e, t, r) {
    return t === this.routingParam ? {
      ...e,
      [t]: r
    } : this.getCurrentlyResolvedStepParamsObjectSchemaHandler(e).getUpdatedState(
      e,
      t,
      r
    );
  }
  getUpdatedParamsConfigState(e, t, r, a) {
    return this.getCurrentlyResolvedStepParamsObjectSchemaHandler(t).getUpdatedParamsConfigState(
      e,
      t,
      r,
      a
    );
  }
  validate(e) {
    return this.getCurrentlyResolvedStepParamsObjectSchemaHandler(e).validate(e);
  }
  getFieldValue(e, t) {
    return this.getCurrentlyResolvedStepParamsObjectSchemaHandler(e).getFieldValue(
      e,
      t
    );
  }
  getInitialState() {
    return {};
  }
}
export {
  v as StepParamsOneOfSchemaHandler
};
